import { Clock, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const TITLES = { privasi: ["Kebijakan Privasi", "privacy"], syarat: ["Syarat Layanan", "terms"] };

export function LegalPage({ kind }) {
  const { settings } = useSettings();
  const [title, key] = TITLES[kind];
  const sections = settings?.[key] || [];
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 lg:py-24" data-testid={`legal-page-${kind}`}>
      <p className="eyebrow">Informasi</p>
      <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">{title}</h1>
      <div className="mt-12 space-y-10">
        {sections.map(({ title: h, body: p }, i) => (
          <section key={`${i}-${h}`} className="grid sm:grid-cols-[48px_1fr] gap-2">
            <span className="font-mono text-sm text-amber-600">{String(i + 1).padStart(2, "0")}</span>
            <div><h2 className="font-display text-lg font-semibold text-slate-900">{h}</h2><p className="mt-2 text-slate-600 leading-relaxed whitespace-pre-line">{p}</p></div>
          </section>
        ))}
      </div>
    </div>
  );
}

const ITEMS = [
  { icon: MapPin, label: "Alamat", key: "address" },
  { icon: MessageCircle, label: "WhatsApp", key: "whatsapp" },
  { icon: Phone, label: "Telepon", key: "phone" },
  { icon: Mail, label: "Email", key: "email" },
  { icon: Clock, label: "Jam operasional", key: "hours" },
];

export function ContactPage() {
  const { settings } = useSettings();
  const contact = settings?.contact || {};
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-testid="contact-page">
      <p className="eyebrow">Kontak</p>
      <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">Hubungi {settings?.site_name || "Kami"}</h1>
      <p className="mt-5 text-slate-600 max-w-xl">Pertanyaan seputar program, pendaftaran, atau pembayaran? Tim kami siap membantu.</p>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {ITEMS.map((it) => (
          <div key={it.label} className="rounded-lg border border-slate-200 p-6 hover:border-amber-400 transition-colors duration-200">
            <it.icon className="h-5 w-5 text-amber-500" />
            <p className="mt-4 text-xs uppercase tracking-widest text-slate-500">{it.label}</p>
            <p className="mt-1 font-semibold text-slate-900" data-testid={`contact-${it.key}`}>{contact[it.key]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
